import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=221ae056&scoped=true&"
import script from "./BookPage.vue?vue&type=script&lang=js&"
export * from "./BookPage.vue?vue&type=script&lang=js&"
import style0 from "./BookPage.vue?vue&type=style&index=0&id=221ae056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ae056",
  null
  
)

export default component.exports